/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RepairOrgPathResponse } from '../../models/repair-org-path-response';

export interface RepairOrgPathAsync$Json$Params {
  companyId: number;
  isValidationOnly?: boolean;
}

export function repairOrgPathAsync$Json(http: HttpClient, rootUrl: string, params: RepairOrgPathAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RepairOrgPathResponse>> {
  const rb = new RequestBuilder(rootUrl, repairOrgPathAsync$Json.PATH, 'post');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.query('isValidationOnly', params.isValidationOnly, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RepairOrgPathResponse>;
    })
  );
}

repairOrgPathAsync$Json.PATH = '/company/{companyId}/repair-org-path';
